import {
  GetMaterializeItemTasksDocument,
  GetMaterializeItemTasksQueryVariables,
  TaskAssigneeFragment,
  TaskItemFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { TaskIdentifier } from 'modules/tasks/lib/task'

interface Props {
  skip: boolean
  variables: GetMaterializeItemTasksQueryVariables
}

export type MaterializedItemTaskType = TaskItemFragment & {
  assignees: TaskAssigneeFragment[]
  assigneesCount: number
}

interface Result {
  tasks: MaterializedItemTaskType[]
  loading: boolean
}

export const useMaterializeItemTasks = ({ skip, variables }: Props): Result => {
  const { data, loading } = useQuery(GetMaterializeItemTasksDocument, {
    skip,
    variables: { ...variables, identifier: TaskIdentifier.Workflow },
  })

  const tasks = data?.tasks.tasks || []

  return {
    tasks: tasks.map((task) => ({
      ...task,
      assignees: task?.assigneesConnection.edges.map((edge) => edge.node),
      assigneesCount: task?.assigneesConnection.totalCount || 0,
    })),
    loading: !tasks || loading,
  }
}
